module.exports = __webpack_public_path__ + "img/HSBC.c5840c20.svg";